var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 10.5C14.644 10.5 15.1663 9.97769 15.1663 9.33335C15.1663 8.68902 14.644 8.16669 13.9997 8.16669C13.3553 8.16669 12.833 8.68902 12.833 9.33335C12.833 9.97769 13.3553 10.5 13.9997 10.5Z",
    fill: "#BABDCC",
    stroke: "#BABDCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 10.5C22.811 10.5 23.3333 9.97769 23.3333 9.33335C23.3333 8.68902 22.811 8.16669 22.1667 8.16669C21.5223 8.16669 21 8.68902 21 9.33335C21 9.97769 21.5223 10.5 22.1667 10.5Z",
    fill: "#BABDCC",
    stroke: "#BABDCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 10.5C6.47799 10.5 7.00033 9.97769 7.00033 9.33335C7.00033 8.68902 6.47799 8.16669 5.83366 8.16669C5.18933 8.16669 4.66699 8.68902 4.66699 9.33335C4.66699 9.97769 5.18933 10.5 5.83366 10.5Z",
    fill: "#BABDCC",
    stroke: "#BABDCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 19.8333C14.644 19.8333 15.1663 19.311 15.1663 18.6667C15.1663 18.0223 14.644 17.5 13.9997 17.5C13.3553 17.5 12.833 18.0223 12.833 18.6667C12.833 19.311 13.3553 19.8333 13.9997 19.8333Z",
    fill: "#BABDCC",
    stroke: "#BABDCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 19.8333C22.811 19.8333 23.3333 19.311 23.3333 18.6667C23.3333 18.0223 22.811 17.5 22.1667 17.5C21.5223 17.5 21 18.0223 21 18.6667C21 19.311 21.5223 19.8333 22.1667 19.8333Z",
    fill: "#BABDCC",
    stroke: "#BABDCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 19.8333C6.47799 19.8333 7.00033 19.311 7.00033 18.6667C7.00033 18.0223 6.47799 17.5 5.83366 17.5C5.18933 17.5 4.66699 18.0223 4.66699 18.6667C4.66699 19.311 5.18933 19.8333 5.83366 19.8333Z",
    fill: "#BABDCC",
    stroke: "#BABDCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.448514d2f31342962eca5f9dcf24844f.svg";
export { ForwardRef as ReactComponent };